// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

// Handles the clicking of the SELECT button when issueing parts to BOMS

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "searchControl", "cancelControl" ]
  static values = {url: String}

  connect() {
    this.initialControls()
  }

  initialControls() {
    this.cancelControlTarget.style.display="none"
    this.searchControlTarget.style.display="inherit"
  }

  cancelSearch(e) {
    e.preventDefault();
    document.querySelectorAll(".edit_bom").forEach(e => e.remove());
    this.initialControls()
  }

  search(e) {
    e.preventDefault();
    // Remove any instances for part_bom_form
    document.querySelectorAll(".edit_bom").forEach(e => e.remove());
    this.cancelControlTarget.style.display="inherit"
    this.searchControlTarget.style.display="none"
    // Grab part list from server
    fetch(this.urlValue)
      .then( (r) => r.text() )
      .then( (html) => {
        const fragment = document
          .createRange()
          .createContextualFragment(html)
        this.element.appendChild(fragment)
      })
  }

}
